import React, { useEffect, useState } from "react";
import { Modal, Box, Typography, Button, Fade, Backdrop } from "@mui/material";
import { usePopupController } from "../lib/usePopupController.jsx";

export default function BBFSalesModalKohberger({ show, setShow }) {
  const { markLeadCaptured } = usePopupController();

  const [dismissCount, setDismissCount] = useState(
    parseInt(sessionStorage.getItem("kohbergerDismissCount") || "0", 10)
  );

  // ✅ Prevent popup if user is at #download section
  useEffect(() => {
    if (window.location.hash === "#download" && show) {
      setShow(false);
    }
  }, [show, setShow]);

  // ✅ Do not show if dismissed permanently
  useEffect(() => {
    if (localStorage.getItem("kohbergerPopupDismissed") === "true") {
      setShow(false);
    }
  }, [setShow]);

  const handleClose = () => {
    const newCount = dismissCount + 1;
    setDismissCount(newCount);
    sessionStorage.setItem("kohbergerDismissCount", newCount);
    setShow(false);

    if (newCount >= 3) {
      localStorage.setItem("kohbergerPopupDismissed", "true"); // Block permanently after 3 tries
    }
  };

  const handleReserve = () => {
    localStorage.setItem("kohbergerPopupDismissed", "true"); // ✅ Permanent dismiss
    setShow(false);
    window.location.hash = "download";
  };

  return (
    <Modal
      open={show}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={show}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            maxWidth: 420,
            width: "90%",
            borderRadius: 2,
            textAlign: "center",
          }}
        >
          {/* Headline */}
          <Typography
            variant="h5"
            sx={{ fontWeight: "bold", mb: 2, color: "#b71c1c" }}
          >
            LIMITED TIME OFFER
          </Typography>

          <Typography variant="h6" sx={{ mb: 2 }}>
            Get Instant Access to the <strong>Kohberger Dossier</strong>
          </Typography>

          <Box sx={{ textAlign: "left", mb: 3 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              Discover:
            </Typography>
            <ul
              style={{
                paddingLeft: 0,
                margin: 0,
                fontSize: "16px",
                listStyle: "none",
              }}
            >
              <li>✔ The movie that inspired the Moscow Massacre</li>
              <li>✔ His motive, accomplices, and ties to PA</li>
              <li>✔ Why key evidence was ignored — and who covered it up</li>
            </ul>
          </Box>

          {/* Bold one-liner for clarity */}
          <Typography
            sx={{
              fontSize: "14px",
              mb: 1,
              fontWeight: "bold",
              color: "#333",
            }}
          >
            Included in your ZIP download — instant access, no waiting.
          </Typography>

          {/* Italic line for impact */}
          <Typography
            sx={{
              fontSize: "14px",
              mb: 2,
              color: "#555",
              fontStyle: "italic",
            }}
          >
            Help bring justice to the families and victims of 11/13/22.
          </Typography>

          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleReserve}
            sx={{ mb: 2, fontSize: "16px", fontWeight: "bold", py: 1.2 }}
          >
            ✅ GET INSTANT ACCESS
          </Button>

          <Button variant="outlined" fullWidth onClick={handleClose}>
            Maybe Later
          </Button>
        </Box>
      </Fade>
    </Modal>
  );
}
